import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel, Step, StepLabel,
    Stepper,
    Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import PostprocessorsService from "../../../API/details/organization/PostprocessorsService";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import Machines from "./Machines";
import ModalConfirm from "../../../components/UI/modal/ModalConfirm";
import Radio from "@mui/material/Radio";

const Postprocessors = ({itemId, handleModalAlert, isModal, selectedString, setSelectedString}) => {
        const navigate = useNavigate();

        const {pathname, search} = useLocation()
        const [data, setData] = useState([]);
        const [modal, setModal] = useState(false);
        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [submitMachineDefault, setSubmitMachineDefault] = useState(false)
        const [tableOptions, setTableOptions] = useState({
            pageIndex: 0,
            pageSize: 100,
            totalElements: 0,
            searchData: ""
        })
        const id = new URLSearchParams(search).get('id');
        const [loading, setLoading] = useState(false)

        useEffect(() => {
            getStartPageSize()
            PostprocessorsService.getAll().then(function (response) {
                setData(response.data);
                setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
                if (id) {
                    const currentEditRowData = response.data.find(el => el.id === Number(id))
                    setCurrentEditRowData(currentEditRowData)
                    setModal(true)
                }
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, []);

        const tableOptionsHandle = (nextState) => {
            setTableOptions(nextState)
            if (nextState.pageSize !== tableOptions.pageSize) {
                EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
            }
        }

        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
            pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
        }

        const handleAdd = () => {
            setModal(true)
        }
        const handleClose = () => {
            setModal(false)
            setCurrentEditRowData(null)
            setSubmitMachineDefault(false)
            id && navigate('/settings')
        }

        const handleSubmit = (data, close, machineId) => {
            setLoading(true)
            PostprocessorsService.save(machineId, data.name)
                .then(function (response) {
                    setData(prev => [...prev, response.data])
                    setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
                    close()
                    handleModalAlert("Данные добавлены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
                .finally(() => setLoading(false))
        }
        const handleDelete = (row) => {
            PostprocessorsService.delete(row.id)
                .then(function () {
                    setData(prev => prev.filter(el => el.id !== row.id))
                    setTableOptions((prev) => ({...prev, totalElements: data.length - 1}))
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
        };
        const handleMachineDefault = (row) => {
            setSubmitMachineDefault(true)
            setCurrentEditRowData(row)
        }
        const handleSubmitMachineDefault = () => {
            PostprocessorsService.setMachineDefault(currentEditRowData.id)
                .then(function (response) {
                    setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                    handleClose()
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
        }
        const setDefaultSettings = (row) => {
            PostprocessorsService.unableDefault(row.id)
                .then(function () {
                    setData(prev => prev.map(el => el.id === row.id
                        ? {...el, defaultSettings: true}
                        : {...el, defaultSettings: false}
                    ))
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }

        const columns = useMemo(
            () => [
                {
                    id: 'name',
                    header: 'Наименование',
                    accessorKey: 'name',
                    minSize: 300,
                    Cell: ({cell, row}) => <Link to={`/settings/postprocessor/${row.original.id}`}>{cell.getValue()}</Link>,
                },
                {
                    id: 'machine',
                    header: 'Станок',
                    accessorKey: 'machine.name',
                    minSize: 200,

                },
                {
                    id: 'defaultSettings',
                    header: 'По умочанию',
                    accessorKey: 'defaultSettings',
                    maxSize: 200,
                    enableColumnActions: false,
                    Cell: ({cell, row}) => <Radio
                        onChange={() => setDefaultSettings(row.original)}
                        checked={row.original.defaultSettings}
                        sx={{'& .MuiSvgIcon-root': {fontSize: 20}}}
                    />
                },
            ],
            [data, setData],
        );

        const menuItem = [
            {type: "delete", text: "Удалить", handler: handleDelete},
            {type: "setMachineDefault", text: "Автоматически настроить", handler: handleMachineDefault}
        ]
        return (
            <Box
                sx={{
                    overflow: 'auto',
                    maxWidth: isModal ? "100%" : 'calc(100vw - 410px)',
                }}
            >
                {!isModal && <Box
                    sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
                >
                    <Typography sx={{fontSize: "24px", fontWeight: 700}}>Настройки постпроцессоров</Typography>
                    <ButtonCreate
                        text={"Добавить"}
                        width={150}
                        onClick={handleAdd}
                    />
                </Box>}
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            maxHeight: isModal ? "100%" : `calc(100vh - 420px)`,
                        }
                    }}
                    muiTableBodyCellProps={({cell, table}) => {
                        return ({
                            sx: () => ({
                                p: cell.column.id === "name" || cell.column.id === "machine" ? '0px 0px 0px 10px' : 0,
                                m: '0px 0px 0px 0px',
                                border: "none",
                                textAlign: cell.column.id === "name" || cell.column.id === "machine" ? "left" : "center",
                                "&:after": {
                                    display: "none",
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                "&:first-of-type": !isModal && {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => !modal && theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },

                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                }

                            })
                        })
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            onClick: () => isModal && setSelectedString(row.original),
                            sx: () => ({
                                height: '36px',
                                cursor: isModal && "pointer",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                    },
                                },
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : "white",
                                "&:hover": {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                            })
                        })
                    }}

                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: 10,
                            grow: false,
                        },
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    columns={columns}
                    data={data}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        return <MenuItem
                            key={el.type}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    state={{showGlobalFilter: true, pagination: tableOptions,}}
                    rowCount={tableOptions.totalElements}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        pagination: {pageIndex: 0, pageSize: 100},
                    }}
                    localization={MRT_Localization_RU}
                    enableRowActions={!isModal}
                    enableToolbarInternalActions={false}
                />
                {modal && <PostprocessorModal
                    title={"Добавить"}
                    open={modal} onClose={handleClose}
                    handleSubmit={handleSubmit}
                    handleModalAlert={handleModalAlert}
                    loading={loading}/>}
                <ModalConfirm
                    title={"Автоматически настроить по инструментам?"}
                    modalOpen={submitMachineDefault}
                    handleClose={handleClose}
                    handleSubmit={handleSubmitMachineDefault}
                    action={"Подтвердить"}
                />
            </Box>
        );
    }
;
export const PostprocessorModal = ({open, onClose, handleSubmit, title, handleModalAlert, loading}) => {
    const [formState, setFormState] = useState({name: ""})
    const [validationState, setValidationState] = useState({name: ""})
    const [activeStep, setActiveStep] = useState(0)
    const [selectedString, setSelectedString] = useState({})


    const handleClose = () => {
        setFormState({name: ""})
        setValidationState({name: ""})
        onClose()
        setActiveStep(0)
        setSelectedString({})
    }
    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {
            if (value === "") {
                newErrors[name] = "пустое поле"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            handleSubmit(formState, handleClose, selectedString?.id)
        }
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: activeStep === 0 ? "800px" : "400px",
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{title}</DialogTitle>
                <Stepper
                    style={{width: 446}}
                    activeStep={activeStep}
                >
                    {["Станки", "Наименование"].map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <DialogContent sx={{padding: "2px 24px"}}>
                {activeStep === 0 ?
                    <Machines handleModalAlert={handleModalAlert} isModal={true} selectedString={selectedString}
                              setSelectedString={setSelectedString}/> :
                    <TextFieldValidation
                        name={"name"}
                        value={formState?.name}
                        label={"Наименование"}
                        setCurrValues={setFormState}
                        validationError={validationState?.name}
                        setValidationState={setValidationState}
                        margin={"none"}
                    />
                }
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd
                    loading={loading}
                    text={"Выбрать"}
                    onClick={activeStep === 0 ? () => setActiveStep(1) : handleValidationData}
                    disabled={activeStep === 0 && !selectedString?.id}/>
            </DialogActions>
        </Dialog>
    );
}

export default Postprocessors;